<template lang="pug">
  .component-search-vehicle-availability
    h2 Availability
    backoffice-vehicle-availability(v-if="availability.length", :availability.sync="availability", @slotsSelected="slotSelected", :selectable="selectable",  @loadExtra="showExtraDay")
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BackofficeVehicleAvailability from './VehicleAvailability'
  import DatePicker from '../structure/DatePicker'

  export default {
    name: 'SearchVehicleAvailability',
    components: {
      DatePicker,
      BackofficeVehicleAvailability,
    },
    data() {
      return {
        availability: [],
        start: null,
        end: null,
      }
    },
    created() {
      this.start = this.$date().minutes(0).seconds(0)
      this.end = this.$date().add(2, 'days').minutes(0).seconds(0)
      this.getAvailability()
    },
    methods: {
      slotSelected(obj) {
        this.$emit('slotsSelected', obj)
      },
      search() {
        this.start = this.$date(this.start)
        this.end = this.$date(this.end)
        this.getAvailability()
      },
      getAvailability() {
        KeplerBackofficeSdk.vehicles.select(this.vehicle, {
          start: this.start.unix(),
          end: this.end.unix()
        }).availability((data) => {
          data.forEach((a) => {
            Object.assign(a, {selected: false})
          })
          this.availability = data
        })
      },
      showExtraDay() {
        this.end = this.$date(this.end).add(1, 'days').hours(23).minutes(30).seconds(0)
        this.getAvailability()
      }
    },
    computed: {},
    props: ['vehicle', 'selectable'],
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-tabbed-vehicle-availability
    background: white

</style>



// WEBPACK FOOTER //
// SearchVehicleAvailability.vue?af933a82